var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8762 19.2279C28.0012 23.6029 24.7025 27.7224 20.0737 28.6429C17.8162 29.0924 15.4744 28.8183 13.3818 27.8595C11.2891 26.9008 9.55226 25.3062 8.41856 23.3029C7.28487 21.2996 6.81211 18.9897 7.06759 16.702C7.32307 14.4144 8.29378 12.2657 9.8415 10.5619C13.016 7.06536 18.3762 6.10286 22.7512 7.85286",
    stroke: "#24AEF8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.4778L18.375 21.8528L28.875 10.4778",
    stroke: "#24AEF8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircleTick);
export default __webpack_public_path__ + "static/media/blue-circle-tick.d29ef2397fa7a2a452409197a7311e5f.svg";
export { ForwardRef as ReactComponent };